import React from 'react';

import './style.scss';

const Button = (props) => {
  const { slideIndex, nextSlide, buttonType, text, style } = props;

  const checkButton = (node) => {
    if (node && buttonType === 'fixed') {
      const divnode = document.getElementById(
        `button-fixed-extra-div-${slideIndex}`
      );

      divnode.style.minHeight = `${node.clientHeight - 16}px`;
    }
  };

  return (
    <div
      className={`button-container ${
        buttonType === 'scroll' ? 'button-scroll' : 'button-fixed'
      }`}
      id='button-id'
      ref={checkButton}
    >
      <button className='button' onClick={nextSlide} style={{ ...style }}>
        {text}
      </button>
    </div>
  );
};

export default Button;
